<template>
  <div>
    <v-card
      class="pa-0 d-flex align-items-center justify-center rounded-pill elevation-0 grid-container"
      style="width: max-content; height: 20px"
    >
      <v-col
        v-for="item in shortItems"
        :key="item.id"
        style="width: 19px"
        class="pa-0 align-items-center justify-center"
      >
        <v-menu open-on-hover top offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              elevation="0"
              style="height: 17px; width: 17px; font-size: 12px;"
              tone
              fab
              dark
              x-small
              v-bind="attrs"
              v-on="on"
              :class="getColor()"
            >
              {{ getSkillAvatar(item.element.title) }}
            </v-btn>
          </template>

          <div class="modalSkills">
            <div class="group-block">
              <h6 class="group-block-name">{{ item.element.title }}</h6>
              
              <div v-if="item.element && item.element.viewerRights && item.element.viewerRights.canViewScore">
                <div v-if="item.score.score == null"><b>0</b></div>
                <div v-else><b>{{ getNumber(item.score.score) }}</b></div>
              </div>
              
            </div>
          </div>
          
        </v-menu>
      </v-col>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-col class="pa-1 d-flex align-items-center justify-center">
            <v-btn
              v-if="hasMore"
              class="pa-0 rounded-pill align-items-center justify-center"
              elevation="0"
              fab
              dark
              x-small
              style="height: 15px; width: 30px"
              text
              color="grey"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark right style="margin-left: 0" x-small>
                mdi-plus
              </v-icon>
              <span style="font-size: 8px">{{ menuItems.length }}</span>
            </v-btn>
          </v-col>
        </template>

        <div class="modalSkills">
          <div class="itemSkill" v-for="(skill, index) in menuItems">
            <div class="group-block">
              <h6 class="group-block-name">{{ skill.element.title }}</h6>
              <div v-if="skill.score.score == null"><b>0</b></div>
              <div v-else><b>{{ getNumber(skill.score.score) }}</b></div>
            </div>
            
          </div>
        </div>

      </v-menu>
    </v-card>
  </div>
</template>

<script>
import globalMethods from "@/plugins/globalMethods";
export default {
  name: "AvatarsGroup",

  props: {
    items: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: "hard"
    },
    limit: {
      type: Number,
      default: 5
    },
    showMore: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    normalizedItems() {
      return Array.isArray(this.items) ? this.items : [];
    },
    shortItems() {
      const lim = Number(this.limit) || 0;
      if (lim <= 0) return [];
      return this.normalizedItems.slice(0, lim);
    },

    menuItems() {
      const lim = Number(this.limit) || 0;
      if (lim <= 0) return this.normalizedItems;
      return this.normalizedItems.slice(lim);
    },

    hasMore() {
      return this.showMore && this.menuItems.length > 0;
    }
  },

  data() {
    return {
      char: "",
    };
  },

  // mounted() {
  //   console.log(this.items)
  // },

  methods: {
    getColor() {
      if (this.type == "hard") return "primary-bg";
      else return "secondary-bg";
    },

    getSkillAvatar(skillName) {
      if (!skillName) return "";
      return String(skillName)[0].toUpperCase();
    },

    getNumber(num) {
      return globalMethods.getNumber(num)
    }
  },
};
</script>
<style scoped>
  .modalSkills {
    background: #fff;
    padding: 10px 15px;
    font-family: 'Montserrat', sans-serif;
  }
  .modalSkills h6 {
    font-size: 13px;
    text-align: left;
    margin-bottom: 0;
    text-transform: none;
    font-weight: 400;
  }
  .modalSkills .itemSkill {
    padding: 5px 0;
  }
  .group-block {
    display: flex; 
    justify-content: space-between; 
    width: 100%; 
    align-items: center;
  }
  .group-block-name {
    width: 90%;
    margin-right: 20px;
    line-height: 1;
  }
</style>
